import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ErrorPage from "./error-page";
import { Typography, Button, Table,  TableHead, TableBody, TableCell, TableRow, } from '@mui/material';

const ChatHeader = () => {
  useEffect(() => {
    document.title = "Booking";
  }, []);

  return (
    <Typography variant="h4" align="center" gutterBottom>
      Booking List
    </Typography>
  );
};

const SessionList = ({ sessions, userId }) => {


  if (!Array.isArray(sessions) || sessions.length === 0) {
    return <p>No sessions available</p>;
  }

  return (
    <div style={{ textAlign: 'left' }}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Student</TableCell>
            <TableCell>Teacher</TableCell>
            <TableCell>Start Time</TableCell>
            <TableCell>End Time</TableCell>
            <TableCell>Booking Status</TableCell>
            <TableCell>Course Status</TableCell>
            <TableCell>Date</TableCell>
            <TableCell>Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {sessions.map((sessionElement) => (
            <TableRow key={sessionElement.session_id}>
              <TableCell>{sessionElement.student_username}</TableCell>
              <TableCell>{sessionElement.teacher_username}</TableCell>
              <TableCell>{sessionElement.start_time}</TableCell>
              <TableCell>{sessionElement.end_time}</TableCell>
              <TableCell>
                {sessionElement.booking_status === 1 ? 'Booked (Approved)' : 'Not Yet Approved'}
              </TableCell>
              <TableCell>
                {sessionElement.course_status === 0 ? 'Not Yet Started' : 'Canceled'}
              </TableCell>
              <TableCell>{sessionElement.add_time}</TableCell>
              <TableCell>
                {sessionElement.course_status === 0 && (
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={() => {
                      // Handle cancel button click if needed
                      // You can add your custom logic here
                    }}
                  >
                    Cancel
                  </Button>
                )}

                {sessionElement.course_status === -1 && (
                  <Button
                    variant="contained"
                    color="secondary"
                    disabled
                  >
                    Canceled
                  </Button>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
function App() {
  const [sessions, setSessions] = useState([]);
  const [userExists, setUserExists] = useState(false);
  const [userCredentials, setUserCredentials] = useState(null);
  const { id, user_name, key,user_type } = useParams();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const apiUrl = "/api/get_user_credentials";
    
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id,
            user_name,
            key,
            user_type
          }),
        });

        if (!response.ok) {
          throw new Error(`Error fetching user credentials: ${response.status} - ${response.statusText}`);
        }

        const result = await response.json();
        setUserCredentials(result);

        const checkUserUrl = "/api/check_user";
    
        
        const checkUserResponse = await fetch(checkUserUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: result.id,
            user_name: result.user_name,
            key: result.key,
            user_type: result.user_type,
          }),
        });

        if (!checkUserResponse.ok) {
          throw new Error(`Error checking user existence: ${checkUserResponse.status} - ${checkUserResponse.statusText}`);
        }

        const userExistsResult = await checkUserResponse.json();
        setUserExists(userExistsResult.exists);
      } catch (error) {
        console.error("Error:", error.message);
      }
    };

    fetchData();
  }, [id, user_name, key,user_type]);
  const handleGetData = (dataType = '', student_id = '', student_username = '', teacher_id = '', teacher_username = '', start_time = '', end_time = '', booking_status = '', course_status = '') => {
    const apiUrl = "/api/booking_handler";
  
    let bodyMsg = {
      data_type: dataType,
      student_id: student_id,
      student_username: student_username,
      teacher_id: teacher_id,
      teacher_username: teacher_username,
      start_time: start_time,
      booking_status: booking_status,
      course_status: course_status,
      end_time: end_time,
    };
  
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(bodyMsg),
    };
  
    fetch(apiUrl, requestOptions)
      .then((api_response) => api_response.json())
      .then((data) => {
        const parsedData = JSON.parse(data.body);
        console.log("API Response:", parsedData);
        let response = parsedData.data;
  
        if (dataType === 'booking_list') {
          // Log the student_id
          console.log("Student ID:", student_id);
        
          // Filter sessions based on student_id (convert to number for strict equality)
          const filteredSessions = response.filter(
            (sessionElement) => sessionElement.student_id === Number(student_id)
          );
        
          console.log("Filtered Sessions:", filteredSessions);
          setSessions(filteredSessions);
        } else {
          console.log('dataType not booking_list ' + dataType);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };
  

  if (userCredentials && userExists && user_type ==='1') {
    return (
      <>
        <ChatHeader />
        <div>
          <div>
          <Button
  variant="contained"
  onClick={() => {
    handleGetData('booking_list', id.toString());
  }}>
  Get Bookings
</Button>
            <SessionList sessions={sessions} />
          </div>
        </div>
      </>
    );
  } else {
    return <div><ErrorPage /></div>;
  }
}

export default App;
